import Api from './Api.service';
export default class PersonaService {
    static ObtenerDatosPersonalesPorDni(dni) {
        return Api.get(`ca/data/${dni}`);
    }
    static ObtenerCausasPorIdProntuario(IdProntuario) {
        return Api.get(`/causas/${IdProntuario}`);
    }
    
    static ObtenerDocente(dni) {
        return Api.get(`/docente/${dni}`);
    }
}